import { motion } from "framer-motion";

const KOLAM_BG =
  "https://images.unsplash.com/photo-1739242895622-ed842c09d596?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHBhdHRlcm4lMjB0YW1pbCUyMG5hZHUlMjBhcnR8ZW58MHx8fHwxNzg2Mjk2NjAyfDA&ixlib=rb-4.1.0&q=85";

const CHAPTERS = [
  {
    num: "01",
    title: "Pick your variant",
    body: "Dear, KL or Golden Raja — every chart family lives under one roof. Choose your lane and today's charts open up, clean and organised.",
  },
  {
    num: "02",
    title: "Choose your chart",
    body: "Dear drops at 1PM, 6PM & 8PM. KL at 3PM. Golden Raja — all four draws in one combined chart, split into 5D, 4D & 3D.",
  },
  {
    num: "03",
    title: "Download & share",
    body: "Screenshot it, download it, or blast it straight to WhatsApp and Telegram. Built for speed, made to be forwarded.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative overflow-hidden px-6 py-32 md:px-16 lg:px-24">
      <img
        src={KOLAM_BG}
        alt=""
        className="pointer-events-none absolute inset-0 h-full w-full scale-110 object-cover opacity-[0.07] blur-sm"
      />
      <div className="relative z-10 mx-auto max-w-[1400px]">
        <p className="mb-20 font-mono text-xs uppercase tracking-[0.3em] text-[#666666]" data-testid="manifesto-overline">
          The Manifesto
        </p>
        <div className="space-y-28">
          {CHAPTERS.map((chapter, i) => (
            <motion.div
              key={chapter.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: i * 0.08 }}
              className="grid grid-cols-1 gap-8 md:grid-cols-12"
              data-testid={`manifesto-chapter-${chapter.num}`}
            >
              <div className="md:col-span-3">
                <span className="font-editorial text-8xl italic leading-none text-white/15 md:text-9xl">
                  {chapter.num}
                </span>
              </div>
              <div className="md:col-span-7 md:col-start-5">
                <h3 className="mb-6 font-heading text-2xl font-bold uppercase tracking-tight md:text-4xl">
                  {chapter.title}
                </h3>
                <p className="max-w-xl text-base leading-relaxed text-[#A1A1A6] md:text-lg">{chapter.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
